'use strict';

var RestUtils = require('utils/RestUtils'),
    Security = require('services/Security').auth,
    apiAppUrl = process.env.URL_API,
    signUpService;

signUpService = {

    signUp: function(singUp, onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                const token = this.getResponseHeader('X-AUTH-TOKEN');
                if (token) {
                    Security.loginFromSignUp(token, singUp.username);
                } else {
                    onFailure.bind(this)({ message: 'No token found in response' });
                }
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText));
            });
        });

        ajax.open('POST', apiAppUrl + '/signup', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send(JSON.stringify(singUp));

        try {
            if (window.rdt) {
                window.rdt('track', 'SignUp', {
                    'currency': 'USD',
                    'value': 100
                });
            }
        } catch (e) {
            console.log('Error in reddit tracking', e);
        }
    }

};

exports.signUpService = signUpService;



/** WEBPACK FOOTER **
 ** ./src/services/SignUpServiceImpl.js
 **/